import { useEffect } from "react";

import { CircularProgress, Stack, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import { isUserAccountActivationFlow, SUPPORT_EMAIL } from "constants/index";
import { useAuthContext } from "hooks";
import { rebuildEmailAlias } from "utils";

import type { ActivationFlow } from "constants/index";

export function VoluntellLoginContainer() {
  const [searchParams] = useSearchParams();
  const { login, isLoading, attemptedVoluntellLogin, loginErrorMsg } =
    useAuthContext();

  const email = searchParams.get("email") ?? null;
  const password = searchParams.get("encoded") ?? null;
  const shipment = searchParams.get("shipment") ?? null;
  const readFlow = searchParams.get("flow") ?? null;
  const flow: ActivationFlow | null = isUserAccountActivationFlow(readFlow)
    ? readFlow
    : null;
  const canAttemptLogin = email != null && password != null;

  useEffect(() => {
    if (canAttemptLogin && !attemptedVoluntellLogin) {
      const cleanedEmail = rebuildEmailAlias(email);
      login({
        email: cleanedEmail as string,
        password,
        voluntellLogin: true,
        shipmentId: shipment,
        flow,
      });
    }
  }, [
    canAttemptLogin,
    email,
    password,
    attemptedVoluntellLogin,
    login,
    shipment,
    flow,
  ]);

  const errorMsg = `Login information not found. Please contact ${SUPPORT_EMAIL}.`;

  if (attemptedVoluntellLogin && !isLoading && loginErrorMsg != null) {
    return (
      <Typography textAlign="center" variant="h6">
        {errorMsg}
      </Typography>
    );
  }

  return (
    <Stack alignItems="center">
      <Typography textAlign="center" variant="h6">
        Activating your account...
      </Typography>

      <CircularProgress />
    </Stack>
  );
}
